module.exports = __webpack_public_path__ + "img/symbol_6.29ce5832.png";